/* eslint-disable eol-last */
import { User } from '../services/api/User'

export const getUserName = ({
  id,
  login,
  passport,
}: User) => {
  return passport && passport?.surname && passport?.name
    ? `${passport.name} ${passport.surname.slice(0, 1)}.`
    : login
      ? login
      : `ID: ${id}`
}

export const blurPhone = (phone: string | null): string => {
  const length = phone?.length

  if (!length || length <= 4) {
    return '*****'
  }

  const firstPart = phone.substring(0, 3)
  const lastPart = phone.substring(phone.length - 2, phone.length)

  return `${firstPart}******${lastPart}`
}
